import { createSelector, Selector } from 'reselect';
import { selectGranulometry } from './current.selector';
import { State } from '../../../store/reducers';

export const selectHasGranulometry: Selector<State, boolean> = createSelector(
  [selectGranulometry],
  Boolean
);
